module.exports = __webpack_public_path__ + "img/2021_10_dande_koushouji_fin_web.9d252a51.jpg";